import api from '../../api';
import { updateTeacherPeriods } from '../../redux/slices/teacherAccountSlice';

export const teachingPlanService = {
    // Get course details with plan
    getPlanDetails: async (planId) => {
        try {
            const response = await api.get(`/teaching-plans/${planId}/details`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teaching plan:', error);
            throw error;
        }
    },

    addCourse: async (planId, courseData) => {
        try {
            const response = await api.post(`/teaching-plans/${planId}/courses`, courseData);
            return response.data;
        } catch (error) {
            console.error('Error adding course to teaching plan:', error);
            throw error;
        }
    }
    // Create a new teaching plan

    // updatePlan: async (planId, planData) => {
    //     try {
    //         const response = await api.put(`/teaching-plans/${planId}`, planData);
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error updating teaching plan:', error);
    //         throw error;
    //     }
    // }
};

export default teachingPlanService;
